/** Supported REVA UI languages. */
export type RevaLanguage = "de" | "en";

/**
 * Select a value depending on the given language.
 *
 * @param language the provided language ("de" is the default / fallback)
 * @param deOption option to select when the language is not "en"
 * @param enOption option to select when the language is "en"
 * @return the selected value
 */
export function selectByLanguage<T>(language: RevaLanguage | null | undefined, deOption: T, enOption: T): T {
    return language === "en" ? enOption : deOption;
}
